import { COLOR_TOKENS } from '@backrs_ui/common-ui/src/designSystem/colors/colors';

import { Box, SxProps, Theme } from '@mui/material';
import { Chart as ChartJS, ArcElement, Tooltip, ChartData, ChartOptions } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

const FIGMA_CHART_DIAMETER = 120;

ChartJS.register(ArcElement, Tooltip);

export type DonutChartProps = Readonly<{
  percentageFilled: number;
}>;

export const DonutChart = ({ percentageFilled }: DonutChartProps) => {
  // Ensure the percentageFilled is between 0 and 100
  const safeValue = Math.min(100, Math.max(0, percentageFilled));

  const chartData: ChartData<'doughnut'> = {
    datasets: [
      {
        data: [safeValue, 100 - safeValue],
        backgroundColor: [
          COLOR_TOKENS['Colors/Border/border-brand'],
          COLOR_TOKENS['Colors/Border/border-secondary'],
        ],
        borderColor: COLOR_TOKENS['Colors/Base/Black'],
        borderWidth: 1,
        borderRadius: 0,
        weight: 1,
      },
    ],
  };

  const options: ChartOptions<'doughnut'> = {
    responsive: true,
    maintainAspectRatio: true,
    aspectRatio: 1,
    cutout: '50%',
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
      },
    },
    rotation: (-90 * Math.PI) / 180,
  };

  return (
    <Box sx={containerSx}>
      <Doughnut data={chartData} options={options} />
    </Box>
  );
};

const containerSx: SxProps<Theme> = {
  width: `${FIGMA_CHART_DIAMETER}px`,
  height: `${FIGMA_CHART_DIAMETER}px`,
};
